import { render } from "./Listado.vue?vue&type=template&id=cb07310a"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__